import React from "react";
import image1 from "../images/LudoBlue/Gemini_Generated_Image_w22ksiw22ksiw22k.png";
import { Link } from "react-router-dom";


function Home(props) {
  return (
    <div>      
      <div class="container my-5">
  <div class="row align-items-center">
    <div class="col-md-6">
      <h1>Bienvenue chez LudoBlue !</h1>
          <p>Au cœur de notre communauté, LudoBlue est bien plus qu'une simple bibliothèque de jeux. C'est un espace de découverte, de partage et de rires pour tous les âges. Nous croyons fermement que le jeu est essentiel : il tisse des liens, éveille la curiosité et crée des souvenirs inoubliables.
</p>
          <p>Que vous soyez un joueur passionné, un parent cherchant à partager un moment unique avec ses enfants, ou une structure désireuse d'animer un événement, vous trouverez votre bonheur parmi nos centaines de références.</p>
          <h3>Explorez notre univers :</h3>
          <ul>
  <li>Empruntez des jeux pour animer vos soirées en famille ou entre amis.</li>
  <li>Découvrez nos animations et événements thématiques tout au long de l'année.</li>
  <li>Faites appel à notre ludothèque itinérante pour amener la magie du jeu jusqu'à vous!</li>
</ul>
          <p>Prêts à jouer ? L'aventure LudoBlue commence ici.</p>
    </div>
    <div class="col-md-6">
      <img src={image1} alt="Description" class="img-fluid rounded"></img>
    </div>
    
  </div>
</div>
      <div class="text-center">


<h2>Découvrez notre vaste collection de jeux !</h2>
          <Link to="/jeux" className="nav-link active" aria-current="page">
          <button type="button" class="btn btn-primary" >Notre collection de jeux</button>
          </Link>
          <p>Rejoignez-nous dès aujourd'hui et plongez dans un monde de divertissement sans fin!</p>
      </div>
<div class="container my-5">

      <div id="carouselExample" class="carousel slide">
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img
              src="https://images.unsplash.com/photo-1719494206741-79831f9f4d51?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              class="d-block w-100"
              alt="..."
              width="253"
              height="800"
            />
            <div class="carousel-caption d-none d-md-block">
        <h3>Nous avons une grande variété,</h3>
        <p>Pour les petits comme pour les grands.</p>
      </div>
          </div>
          <div class="carousel-item">
            <img
              src="https://plus.unsplash.com/premium_photo-1718232331177-298562d142d9?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              class="d-block w-100"
              alt="..."
              width="253"
              height="800"
            />
            <div class="carousel-caption d-none d-md-block">
        <h3>Venez jouer</h3>
        <p>En famille, entre amis ou collégue</p>
      </div>
          </div>
          <div class="carousel-item">
            <img
              src="https://images.unsplash.com/photo-1585504198199-20277593b94f?q=80&w=1317&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              class="d-block w-100"
              alt="..."
              width="253"
              height="800"
            />
          </div>
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    
     </div> 



      <div class="text-center">
        <form
          id="sib-form"
          method="POST"
          action="https://b2a056a9.sibforms.com/serve/MUIEAGI6X8yS36oaRWpLiBjvpUAkqS2ZRJg-fi6Dnes4Zf3WFz44-nTzOqphlP3THWgUflbx59Jd9bxbGAqK385Na8wZ8qnQK3JTGklJTrXYATZf4xqWQtAasODrZLX-chfHp5azUNwyJy_lGKElriW1ud7KzBYD3MVPYS4Ib-sprxngj6Lc2X6o_04c_024okqCXGmzWnFLJ7k4"
          data-type="subscription"
          novalidate="true"
        >
         
      
          <div>
          
          </div>
        </form>
      </div>
    </div>
  );
}

export default Home;
